import { render, staticRenderFns } from "./RVLAditionalinformation.vue?vue&type=template&id=1a8ddc8a&scoped=true"
import script from "./RVLAditionalinformation.vue?vue&type=script&lang=js"
export * from "./RVLAditionalinformation.vue?vue&type=script&lang=js"
import style0 from "./RVLAditionalinformation.vue?vue&type=style&index=0&id=1a8ddc8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8ddc8a",
  null
  
)

export default component.exports